import React from 'react';
import MapComponent from './mapComponent';
import { connect } from 'react-redux';
import load from 'load-script';
import './heatSpot.css';

class HeatMap extends React.Component {
    constructor() {
        super();
        this.state = {
            showInfo:false,
            callHeatMap: false
        };
    }

    componentDidMount() {
        setTimeout(()=>{
            this.setState({
                showInfo:true
            });
        },3000);
      load('https://maps.googleapis.com/maps/api/js?key=AIzaSyDOEDrHL3W3HUA6hk2u59bITUj-a2HgO4U&libraries=visualization', () => {
        this.setState({
          callHeatMap: true
        })
      })
    }

    render() {
        const { businessInfo, HereNow, businessImage } = this.props;
        const { showInfo, callHeatMap } = this.state;
        return (
            <React.Fragment>
                <div className="heatspot-Header-wrapper">
                    <p className="heatspot-heading">{`Curbside Communication`}</p>
                </div>
                <div className="user-place-location">
                    {
                        callHeatMap && businessInfo.BusinessUser.Address_Lat && businessInfo.BusinessUser.Address_Long &&
                        <MapComponent
                            showInfo= {showInfo}
                            googleMapURL='https://maps.googleapis.com/maps/api/js?key=AIzaSyDOEDrHL3W3HUA6hk2u59bITUj-a2HgO4U&libraries=visualization'
                            loadingElement={<div style={{height: '100%'}}/>}
                            containerElement={<div style={{height: `40px`}}/>}
                            mapElement={<div style={{height: `40%`}}/>}
                            style={{height: '1995px', width: '100px'}}
                            businessName={businessInfo && businessInfo.AppUser.FirstName}
                            UsersCheckedIn={HereNow && HereNow.results.TotalRecords}
                            businessPhoto={businessImage}
                            businessInfo={businessInfo}
                        />
                    }
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        businessInfo: state.loginResponse.results,
        businessImage: state.loginResponse.results.AppUser.ProfileImage,
        HereNow: state.heatSpotReducer.HereNow,
    };
};

export default connect(mapStateToProps,null)(HeatMap);

